import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function Title(props) {
    return (
        <Typography
            style={props.style}
            variant="h6"
            className="heading"
            paragraph={props.paragraph}
            to={props.to}
            component={!!props.component ? props.component : "h2"}
            color={props.color ? props.color : "primary"}
            align={props.align ? props.align : "center"}
            gutterBottom
        >
            {props.children}
        </Typography>
    );
}
